import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=dfe8ca76&scoped=true&"
import script from "./RightSidebar.vue?vue&type=script&lang=js&"
export * from "./RightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RightSidebar.vue?vue&type=style&index=0&id=dfe8ca76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe8ca76",
  null
  
)

export default component.exports